import { useCallback } from 'react';
import { useTapDetection } from '../../../shared/hooks/usePointerHandlers';
import { openJackpotStatistics } from '../store/jackpotStatisticsStore';

interface JackpotStatisticsTriggerContext {
  jackpotName: string;
  sectionName: string;
}

type PointerHandlers = {
  onPointerUp: (e: React.PointerEvent) => void;
  onPointerDown: (e: React.PointerEvent) => void;
};

/** Pointer handlers that open the jackpot statistics drawer for a tapped/clicked jackpot level. */
export const useJackpotStatisticsTrigger = ({ jackpotName, sectionName }: JackpotStatisticsTriggerContext) => {
  const { onPointerDown, wasTap } = useTapDetection();

  return useCallback(
    (): PointerHandlers => ({
      onPointerDown,
      onPointerUp: (e) => {
        if (e.pointerType === 'touch' && !wasTap(e)) return;
        openJackpotStatistics({ jackpotName, sectionName });
      },
    }),
    [jackpotName, sectionName, onPointerDown, wasTap],
  );
};
